import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getUserSettingsFetchSuccess,
    getUserSettingsFetchFailure,
    editUserSettingsFetchSuccess,
    editUserSettingsFetchFailure,
} from './reducer';
import { UserSettingsResType, UserSettingsType } from 'src/types/userSettings';

const getUserSettingsFetchRequest = async () => {
    const res = await api('get', `api/secure/users/user-settings`);
    return res.data;
};

function* getUserSettingsFetch() {
    try {
        const response: UserSettingsResType = yield call((): any => getUserSettingsFetchRequest());
        yield put(getUserSettingsFetchSuccess(response));
    } catch (error) {
        yield put(getUserSettingsFetchFailure({ error }));
    }
}

export function* getUserSettingsFetchWatch() {
    yield takeEvery('userSettings/getUserSettingsFetch', getUserSettingsFetch);
}

const editUserSettingsFetchRequest = async (data: UserSettingsType) => {
    const res = await api('put', `api/secure/users/user-settings`, data);
    return res.data;
};

function* editUserSettingsFetch(action: { type: string; payload: UserSettingsType }) {
    try {
        const response: UserSettingsResType = yield call((): any => editUserSettingsFetchRequest(action.payload));
        yield put(editUserSettingsFetchSuccess(response));
    } catch (error) {
        yield put(editUserSettingsFetchFailure({ error }));
    }
}

export function* editUserSettingsFetchWatch() {
    yield takeEvery('userSettings/editUserSettingsFetch', editUserSettingsFetch);
}
